import { AnimationProps } from "framer-motion";

export const titleAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: {
    scale: 0.6,
    opacity: 0,
    transition: { delay: 0, duration: 0.1 },
  },
  transition: { delay: 0.2 },
};

export const telegramCardAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: {
    scale: 0.6,
    opacity: 0,
    transition: { delay: 0, duration: 0.1 },
  },
  transition: { delay: 0.4 },
};

export const notifyAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0, display: "none" },
  animate: { scale: 1, opacity: 1, display: "flex" },
  exit: {
    scale: 0.6,
    opacity: 0,
    display: "none",
    transition: { delay: 0.1 },
  },
};

export const slideContentAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  transition: { duration: 0.3 },
};

export const slideButtonAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: { scale: 0.6, opacity: 0 },
  transition: { delay: 0.2 },
};

export const appSkeletonAnimation: AnimationProps = {
  initial: { scale: 0.6, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  exit: {
    scale: 0.6,
    opacity: 0,
    transition: { delay: 0 },
  },
};
